import React, { PureComponent } from 'react'

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { fetchUsersTxInsights } from '../../actions'

const PageSizeFilter = (props) => {
  const defaultFilter = '50'

  const handleSelectFilter = (e) => {
    const pageSize = e.target.value === defaultFilter ? defaultFilter : e.target.value
    props.updateFilter({ pageSize })
  }

  const defaultFilterStates = ['5', '10', '15', '20', '25', '30', '35', '40', '45', '50']
  return (
    <div className='form-group'>
      <select
        id='pageSize'
        value={props.filter ? props.filter : defaultFilter}
        name='pageSize'
        className='form-control'
        onChange={handleSelectFilter}
      >
        {defaultFilterStates.map((value) => (
          <option key={value} value={String(value)}>
            {`${value} Records`}
          </option>
        ))}
      </select>
    </div>
  )
}

const mapStateToProps = (state) => ({
  searchTerm: state.transactionSearch.searchTerm,
})

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      fetchUsersTxInsights,
      navigateToPage: (p) => ownProps.history.push('#/page/' + p),
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageSizeFilter))
